import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Pagination from './Pagination';

function ArticleTableCalendar({ articles }) {
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [isNarrowScreen, setIsNarrowScreen] = useState(window.innerWidth <= 480);

    // 화면 크기 변화 감지
    useEffect(() => {
        const checkScreenSize = () => {
            setIsNarrowScreen(window.innerWidth <= 490);
        };
        window.addEventListener('resize', checkScreenSize);
        return () => {
            window.removeEventListener('resize', checkScreenSize);
        };
    }, []);

    // 페이지네이션 계산
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = articles.slice(indexOfFirstItem, indexOfLastItem);

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // 각 게시글 클릭 시 새 탭에서 열기
    const handleClick = (article) => {
        const newWindow = window.open();
        newWindow.opener = null;
        newWindow.location = article.link;
    };

    // 날짜 형식 변환
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        // 좁은 화면 여부 상관없이 항상 YYYY-MM-DD 형식으로 출력
        return `${year}-${month}-${day}`;
    };

    return (
        <div className="card has-table">
            <div className="card-content">
                <table>
                    <thead>
                    <tr>
                        <th>Date</th>
                        <th>Title</th>
                        <th>Source</th>
                        <th>Summary</th>
                    </tr>
                    </thead>
                    <tbody>
                    {currentItems.map(article => (
                        <tr key={article.number}>
                            <td>{formatDate(article.date)}</td>
                            <td onClick={() => handleClick(article)} style={{ cursor: 'pointer' }}>
                                {article.title}
                            </td>
                            <td onClick={() => handleClick(article)} style={{ cursor: 'pointer' }}>
                                {article.source}
                            </td>
                            <td onClick={() => handleClick(article)} style={{ cursor: 'pointer' }}>
                                {article.contents}
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                <Pagination
                    itemsPerPage={itemsPerPage}
                    totalItems={articles.length}
                    paginate={paginate}
                    currentPage={currentPage}
                />
            </div>
        </div>
    );
}

ArticleTableCalendar.propTypes = {
    articles: PropTypes.array.isRequired,
};

export default ArticleTableCalendar;
